/**
 * 消息中心
 */
import http from "@/utils/http";

// 我的消息列表
export function announcementUserApi(params) {
    return http.get(`/admin/announcementUser`, params);
}

//全部标位已读
export function announcementSendAllApi(params) {
    return http.get(`/admin/announcementSendAll`, params);
}


// 标记消息已读
export function announcementSendApi(params) {
    return http.get(`/admin/announcementSend`, params);
}